import { getEntityFromScope } from '@bingads-webui/edm-campaign';

export const conversionGoalFields = [
  'Id',
  'Name',
  'Status',
  'Tag',
];

export const fetchConversionGoal = ({
  count,
  scope,
  tagId,
}) => {
  const { currentAccount } = getEntityFromScope(scope);
  const filters = ['Status eq \'Active\''];

  if (tagId != null) {
    const tagIdFilter = Array.isArray(tagId)
      ? `Tag/Id in [${tagId.join(', ')}]`
      : `Tag/Id eq ${tagId}`;
    filters.push(tagIdFilter);
  }

  const query = {
    filter: {
      where: filters.join(' and '),
    },
    select: [...conversionGoalFields],
    top: count || 20,
  };

  return currentAccount.Goals['Default.GetConversionGoals']
    .$makeCall({ query })
    .toPromise();
};

export const transformFetchedGoal = fetchedGoal => ({
  id: fetchedGoal.Id,
  name: fetchedGoal.Name,
  status: fetchedGoal.Status,
});
